export enum MimeTypes {
  PDF = 'application/pdf',
  JPG = 'image/jpg',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
}
